<template>
    <div class="container height-100">
        <div class="wrapper">
            <div class="container-small">      
                <div class="country-selection-block">   
                    <div class="options-navig-block">
                        <div class="options-navig-column selected-country">
                            <input type="text" :value="$store.state.from.countryName" class="input-country input-big" readonly /> 
                            <span class="flag selected-flag" style="top: 30% !important;" :style="{'background-image': 'url(\''+$store.state.from.countryBackgroundImage+'\')'}"></span>
                            <label style="color: #FFF;">{{ $helper.trans('Take_From') }}:</label>
                        </div>
                        <div class="options-navig-column">
                            <input type="text" :value="$store.state.shipperAddressInformation.city" class="input-big" readonly v-if="$helper.needsCity().from"/>
                            <input type="text" :value="$store.state.from.postCode" class="input-big" readonly v-else/>
                        </div>
                    </div>
                    <div class="reverse-block"></div>
                    <div class="options-navig-block">
                        <div class="options-navig-column selected-country">
                            <input type="text" :value="$store.state.to.countryName" class="input-country input-big" readonly />
                            <span class="flag selected-flag" style="top: 30% !important;" :style="{'background-image': 'url(\''+$store.state.to.countryBackgroundImage+'\')'}"></span>
                            <label style="color: #FFF;">{{ $helper.trans('Delivery_to') }}:</label>
                        </div>
                        <div class="options-navig-column">
                            <input type="text" :value="$store.state.deliveryAddressInformation.city" class="input-big" readonly  v-if="$helper.needsCity().to"/>
                            <input type="text" :value="$store.state.to.postCode" class="input-big" readonly v-else/>
                        </div>
                    </div>
                </div>
                <shipping-options-component 
                    @optionSelected="selectCustomShippingOption();"
                    :initialSelect="initialSelect"
                    :customCalculator="true"
                />
                <div class="send-block button-block">
                    <button @click="backStep();" class="btn btn-border radius-4">{{ $helper.trans('Back') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
    props: {
        initialSelect: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    methods: {
        selectCustomShippingOption: function() {  
            let serviceCode = this.$store.state.selectedShippingOption.serviceCode;
            this.$store.state.detailedCosts = this.$store.state.temporaryDetailedCosts[serviceCode];
            this.$store.state.calculatorState = 'summary';  
        },
        backStep: function() {  
            this.$store.state.calculatorState = 'initial';
            this.$store.state.awaitingActions.resetShippings = false;
            this.$store.state.availableShippingOptions = [];
            this.$store.state.selectedShippingOption = [];
            this.$store.state.awaitingActions.shippingOptionsWereReset = true;
            this.$store.state.temporaryDetailedCosts = null;
        }
    },
};
</script>